import { visibleSurfaces, type Surface } from "@csa/web-foundation";
import type { MessageKey } from "../i18n/dictionaries";

// The console's surface registry (ADR 0015 §10/§13) — the per-app list handed to
// the foundation shell. Each surface declares the grant that makes it visible; the
// foundation computes the nav from the principal. The API still enforces every
// call (this is UX). `labelKey` is typed against the console dictionary.
// NB: `queue` stays first so the app's catch-all redirect (SURFACES[0].path)
// keeps landing on a surface every advisor can reach. The RAIL grouping/order is
// presentation and lives in console-shell.tsx (the Fable IA clusters) — this list
// is just the routable registry + its grant gates.
export const SURFACES: Surface<MessageKey>[] = [
  {
    key: "queue",
    path: "/queue",
    labelKey: "nav.queue",
    requires: { permission: "queue:read", scope: "own" },
  },
  // BUGÜN — Günüm dashboard (placeholder until its detail slice lands). Gated on the
  // same advisor grant as the queue so it stays visible to every advisor.
  {
    key: "dashboard",
    path: "/today",
    labelKey: "nav.today",
    requires: { permission: "queue:read", scope: "own" },
  },
  // MÜŞTERİLER — "Müşterilerim" IS the finder (households list; the book is folded in,
  // its /book route kept below). Search is a filter on this one surface.
  {
    key: "households",
    path: "/households",
    labelKey: "nav.households",
    requires: { permission: "party:read", scope: "own" },
  },
  // İLİŞKİ — the CRM relationship cockpit (fırsatlar + segmentler + görevlerim).
  // Gated on opportunity:read@own (every advisor holds it).
  {
    key: "relationships",
    path: "/iliski",
    labelKey: "nav.relationships",
    requires: { permission: "opportunity:read", scope: "own" },
  },
  {
    key: "intake",
    path: "/intake",
    labelKey: "nav.intake",
    requires: { permission: "lead:write", scope: "own" },
  },
  {
    key: "recommendations",
    path: "/recommendations",
    labelKey: "nav.recommendations",
    requires: { permission: "recommendation:read", scope: "own" },
  },
  {
    key: "issuance",
    path: "/issuance",
    labelKey: "nav.issuance",
    requires: { permission: "application:read", scope: "own" },
  },
  {
    key: "claims",
    path: "/claims",
    labelKey: "nav.claims",
    requires: { permission: "claims:read", scope: "own" },
  },
  // İŞ AKIŞI — Yenilemeler (placeholder). Advisor-visible: gated on queue:read@own.
  {
    key: "renewals",
    path: "/renewals",
    labelKey: "nav.renewals",
    requires: { permission: "queue:read", scope: "own" },
  },
  // The approver inbox is visible to any staff principal; the API returns only
  // the approvals they may act on (and never their own — approver ≠ originator).
  { key: "approvals", path: "/approvals", labelKey: "nav.approvals" },
  {
    key: "reconciliation",
    path: "/reconciliation",
    labelKey: "nav.reconciliation",
    requires: { permission: "commission:read", scope: "all" },
  },
  // `reports` was REMOVED from the rail (Sprint D Batch 2). It was registered here but
  // absent from SURFACE_VIEWS, so the only thing it could ever render was the generic
  // "Hazırlanıyor…" placeholder. Org reporting is the ADMIN app's job and is fully built
  // there (/reports/pilot, same analytics:read@all gate) — a second, permanently empty
  // entry in the advisor rail promised a screen the console was never going to grow.
  // HESAP — Bildirimler + Hesap & ayarlar (placeholders, any staff principal).
  { key: "notifications", path: "/notifications", labelKey: "nav.notifications" },
  { key: "settings", path: "/settings", labelKey: "nav.settings" },
  // Folded / non-rail: routes kept working but NOT top-rail entries. `teklif` (manual
  // quote) is reachable within the Öneri/Müşteriler flow; `book` is folded into the
  // "Müşterilerim" finder. Neither appears in a rail cluster (console-shell.tsx).
  {
    key: "teklif",
    path: "/musteri/teklif",
    labelKey: "nav.teklif",
    requires: { permission: "lead:write", scope: "own" },
  },
  {
    key: "book",
    path: "/book",
    labelKey: "nav.book",
    requires: { permission: "party:read", scope: "own" },
  },
];

export { visibleSurfaces };
